<app-content-container [standardPaddingTop]="true">
  <div class="row-space-between">
    <div>
      <h3 class="clickable" (click)="navigateToPublicHomePage()">
        Beauty Booking
      </h3>
      <div>{{ 'footer.text.powered' | translate }}</div>
    </div>

    <div>
      <button mat-button (click)="openLanguageDialog()" style="color: white">
        <img
          class="flag-icon"
          alt="{{ selectedLanguage?.countryCode }}"
          src="/assets/svg-country-flags/{{
            selectedLanguage?.countryCode?.toLowerCase()
          }}.svg"
        />
        <span>{{
          'pipes.language.' + selectedLanguage?.languageCode | translate
        }}</span>
      </button>
    </div>
  </div>

  <lib-spacer></lib-spacer>

  <div>
    <span class="clickable" (click)="navigateToPublicImprintPage()">{{
      'footer.text.imprint' | translate
    }}</span>
    <span class="margin-side">|</span>
    <span class="clickable" (click)="navigateToPublicPrivacyPolicyPage()">{{
      'footer.text.privacy-policy' | translate
    }}</span>
  </div>
</app-content-container>
